export type AppRole = 'user' | 'admin' | 'owner';

export const APP_ROLES: AppRole[] = ['user', 'admin', 'owner'];

export const ROLE_LABELS: Record<AppRole, string> = {
  user: 'User',
  admin: 'Admin',
  owner: 'Owner',
};

type RoleUser = {
  user_metadata?: Record<string, unknown>;
  app_metadata?: Record<string, unknown>;
} | null;

export function getRoleFromUser(user: RoleUser): AppRole {
  if (!user) return 'user';
  const raw =
    (user.user_metadata?.role as string | undefined) ||
    (user.app_metadata?.role as string | undefined);
  if (raw === 'admin' || raw === 'owner') return raw;
  return 'user';
}

export function hasAdminPrivileges(role: AppRole): boolean {
  return role === 'admin' || role === 'owner';
}

export function isOwnerRole(role: AppRole): boolean {
  return role === 'owner';
}

export function isValidAppRole(value: unknown): value is AppRole {
  return value === 'user' || value === 'admin' || value === 'owner';
}
